namespace Areas.Analysis.CIBApprovals
{
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Analysis", ["Unapproved", "Approved"], "CIBApprovals");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function goToProjectCIB(e: any) {
        const grid = $("#CIBApprovalsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].accountId;
            var cibId = row[0].accountCIBId;
            let linkInfo = "/Account/CIB/View/" + id ;
            window.open(linkInfo);
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#CIBApprovalsGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var sharePointLink = row[0].sharePointLink;
            let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
            if (sharePointLink != "") {
                window.open(linkInfo);
            }
            else {
                window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
            }
        }
    }

    export function viewLink(cellElement: any, cellInfo: any) {

        const ids = cellInfo.data.accountId ;

        buildCellContent(cellElement,
            () => { return ids; },
            "<a href= '/Account/CIB/View/{placeholder}'>View</a>");

    }

}
